<div class="language-switcher" (clickOutside)="toggleDropdown(true)">
  <div class="dropdown" (click)="toggleDropdown()">
    <button class="dropdown-toggle">
      {{ selectedLanguageLabel }}
      <span class="arrow"></span>
    </button>
    @if (dropdownOpen) {
      <ul class="language-menu">
        @for (key of languageKeys; track trackByIndex($index)) {
          <li (click)="switchLanguage(key)"> {{ key }} </li>
        }
      </ul>
    }
  </div>
</div>